// Auth0 Configuration
// Replace these values with your Auth0 application credentials
// You can find these in your Auth0 Dashboard -> Applications -> Your App

export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || 'YOUR_AUTH0_DOMAIN',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || 'YOUR_AUTH0_CLIENT_ID',
  redirectUri: window.location.origin,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  scope: 'openid profile email',
};

// To use this, create a .env file in your project root with:
// REACT_APP_AUTH0_DOMAIN=your-domain.auth0.com
// REACT_APP_AUTH0_CLIENT_ID=your-client-id
// REACT_APP_AUTH0_AUDIENCE=your-api-identifier (optional)
